import { Google, Pixall } from '../../analytics/index.js';

/**
* Gathers common wallet analytics data here to simplify GA wallet calls
*
* @usage
* `myWalletClickHelper({ eventResult: 'example::result' }, option);`
*/
const myWalletClickHelper = (data, option) => {
  const {
    eventElement = 'my-wallet',
    eventData = {},
    eventResult,
    withPixallData = false,
    dataLayer = {},
    pixallLabel,
    pixallData = {}
  } = data;
  if (eventResult) {
    Google.sendClickEvent({
      eventElement,
      eventResult,
      eventData
    }, option);
  }
  if (withPixallData && dataLayer) {
    Pixall.sendClickEvent({
      eventSource: 'userAccount',
      eventType: 'click',
      label: pixallLabel || 'my_walt_cont',
      hasListingType: false,
      feature: 'MyWallet',
      ...pixallData
    }, dataLayer, option);
  }
};
export default myWalletClickHelper;